import { IconBookmark, IconBookmarkFilled } from 'app/components/primitive/Icon'
import ContentCard, { ContentCardProps } from './index'
import { Button } from 'app/components/primitive/Button'
import { memo, useCallback } from 'react'

interface ContentCardBookmarkableProps extends ContentCardProps {
  isInWatchLater?: boolean
  onToggleWatchLater?: (id: string) => void
}

const ContentCardBookmarkableComponent = (
  props: ContentCardBookmarkableProps,
) => {
  const {
    isInWatchLater = false,
    onToggleWatchLater,
    videoPost,
    ...cardProps
  } = props

  const handlePress = useCallback(
    () => onToggleWatchLater?.(props.id),
    [onToggleWatchLater, props.id],
  )

  return (
    <ContentCard videoPost={videoPost} {...cardProps}>
      {videoPost && (
        <Button
          circular
          theme={isInWatchLater ? 'white' : 'secondary'}
          onPress={handlePress}
          size="$2"
          br="$pill"
          bw={0}
          $gtSm={{ size: '$3' }}
          aria-label={
            isInWatchLater ? 'Remove from watch later' : 'Add to watch later'
          }
          disabled={!onToggleWatchLater}
          icon={
            isInWatchLater ? (
              <IconBookmarkFilled size={15} />
            ) : (
              <IconBookmark size={16} />
            )
          }
        />
      )}
    </ContentCard>
  )
}

export const ContentCardBookmarkable = memo(
  ContentCardBookmarkableComponent,
) as typeof ContentCardBookmarkableComponent
